<template>
  <router-link
    v-if="visible"
    :to="{ name: 'Orders', params: { orderNumber: this.params.value }}"
    class="text-blue-500 underline"
  >
    {{ params.value }}
  </router-link>
</template>

<script>
export default {
  name: "TasksReportOrderLink",
  computed: {
    visible() {
      if (!this.params.value) {
        return false;
      }

      return this.params.data.Type == 'O';
    }
  }
};
</script>
